@if (showInitials) {
  {{ firstNameInitial }} {{ lastNameInitial }}
} @else {
  {{ firstName }} {{ lastName }}
}
